import * as React from 'react';

export const mtFlagContent: JSX.Element = (
    <>
        <g clip-path='url(#clip0_55_3144)'>
            <rect
                width='28'
                height='20'
                rx='4'
                fill='#E31D1C'
            />
            <mask
                id='mask0_55_3144'
                style={{ maskType: 'alpha' }}
                maskUnits='userSpaceOnUse'
                x='0'
                y='0'
                width='28'
                height='20'
            >
                <path
                    d='M0 4C0 1.79086 1.79086 0 4 0H24C26.2091 0 28 1.79086 28 4V16C28 18.2091 26.2091 20 24 20H4C1.79086 20 0 18.2091 0 16V4Z'
                    fill='#D9D9D9'
                />
            </mask>
            <g mask='url(#mask0_55_3144)'>
                <path
                    d='M0 0H14V20H0V0Z'
                    fill-rule='evenodd'
                    clip-rule='evenodd'
                    fill='white'
                />
                <use
                    xlinkHref='#stroke0_55_3144'
                    fill='#A0A0A0'
                />
                <mask
                    id='stroke1_55_3144'
                    fill='white'
                >
                    <use xlinkHref='#stroke0_55_3144' />
                </mask>
                <path
                    d='M9 4.60742C9.41305 4.67746 9.72747 5.03675 9.72754 5.46973C9.72754 5.47981 9.7269 5.48999 9.72656 5.5H12.5V9H9.63965C9.51859 9.25015 9.28288 9.43343 9 9.48145V12.5H5.5V9.46973C5.2419 9.40839 5.02907 9.23353 4.91602 9H2V5.5H4.8291C4.82876 5.48999 4.82812 5.47982 4.82812 5.46973C4.8282 5.0563 5.11452 4.70958 5.5 4.61816V2H9V4.60742Z'
                    stroke-width='1.75'
                    stroke='#FECA00'
                    mask='url(#stroke1_55_3144)'
                />
            </g>
        </g>
        <defs>
            <clipPath id='clip0_55_3144'>
                <rect
                    width='28'
                    height='20'
                    rx='4'
                    fill='white'
                />
            </clipPath>
            <path
                id='stroke0_55_3144'
                d='M9 4.60742C9.41305 4.67746 9.72747 5.03675 9.72754 5.46973C9.72754 5.47981 9.7269 5.48999 9.72656 5.5H12.5V9H9.63965C9.51859 9.25015 9.28288 9.43343 9 9.48145V12.5H5.5V9.46973C5.2419 9.40839 5.02907 9.23353 4.91602 9H2V5.5H4.8291C4.82876 5.48999 4.82812 5.47982 4.82812 5.46973C4.8282 5.0563 5.11452 4.70958 5.5 4.61816V2H9V4.60742Z'
            />
        </defs>
    </>
);
